import React from "react"

export function LinkRenderer({ href, children }) {
  return (
    <a href={href} target="_blank">
      {children}
    </a>
  )
}

export function flatten(text, child) {
  return typeof child === "string"
    ? text + child
    : React.Children.toArray(child.props.children).reduce(flatten, text)
}

export function HeadingRenderer({ children, level }) {
  const text = React.Children.toArray(children).reduce(flatten, "")
  const slug = text.toLowerCase().replace(/\W/g, "-")
  return React.createElement(`h${level}`, { id: slug }, children)
}
